import { Keys, StateManager } from 'state-manager'

export const redirectToProperPage = async (stateManager: StateManager, searchParams?: URLSearchParams) => {
  // set the parameter in order to know that we will receive data about the user
  // we check this parameter in the method useSmartRedirect
  stateManager.set(Keys.User.Session, undefined)

  await stateManager.invalidate(Keys.User.Session)
  await stateManager.invalidate(Keys.User.Current)
  await stateManager.invalidate(Keys.ClientPortal.Layout)

  if (searchParams) {
    return
  }
}
